import React from "react";
import { ShieldCheck, CreditCard, UtensilsCrossed, Music2 } from "lucide-react";

const ITEMS = [
  {
    id: "age",
    icon: <ShieldCheck size={28} strokeWidth={2.5} />,
    title: "21+ Only",
    body: "Valid government-issued ID required at the door. No exceptions, even if Walter says hi.",
    accent: "#FF2A2A",
  },
  {
    id: "payments",
    icon: <CreditCard size={28} strokeWidth={2.5} />,
    title: "Cash & Cards",
    body: "Both accepted at the bar. Tabs welcome. ATM inside for emergencies.",
    accent: "#FFB800",
  },
  {
    id: "food",
    icon: <UtensilsCrossed size={28} strokeWidth={2.5} />,
    title: "BYO Food Welcome",
    body: "No kitchen here. Grab tacos, pizza, anything local — bring it in, no questions asked.",
    accent: "#FF2A2A",
  },
  {
    id: "noise",
    icon: <Music2 size={28} strokeWidth={2.5} />,
    title: "Loud & Lively",
    body: "Jukebox loud, crowd louder. Come ready to talk to strangers and lose at pool.",
    accent: "#FFB800",
  },
];

const InfoCard = ({ item }) => (
  <div
    data-testid={`kbyg-${item.id}`}
    className="grain-card relative bg-[#0A0A0A] border border-[#262626] p-6 md:p-8 flex gap-5 hover:border-[#FFB800]/40 transition-colors"
  >
    <div
      className="shrink-0 w-14 h-14 flex items-center justify-center"
      style={{ color: item.accent }}
    >
      {item.icon}
    </div>
    <div>
      <div className="font-display text-2xl md:text-3xl text-[#F5F2E6] leading-tight">
        {item.title}
      </div>
      <p className="mt-2 text-sm md:text-base text-[#A3A3A3] leading-relaxed">
        {item.body}
      </p>
    </div>
    <div
      className="absolute top-0 left-0 h-[3px] w-12"
      style={{ background: item.accent }}
    />
  </div>
);

const KnowBeforeYouGo = () => {
  return (
    <section
      id="info"
      data-testid="kbyg-section"
      className="relative px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#121212] border-y border-[#262626]"
    >
      <div className="text-center mb-14">
        <div className="font-mono-plex text-[11px] tracking-[0.3em] uppercase text-[#FFB800] flex items-center justify-center gap-3">
          <span className="h-px w-8 bg-[#FFB800]" />
          06 — Know Before You Go
          <span className="h-px w-8 bg-[#FFB800]" />
        </div>
        <h2 className="mt-4 font-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-[#F5F2E6]">
          A FEW HOUSE <span className="text-[#FF2A2A]">RULES.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
        {ITEMS.map((item) => (
          <InfoCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
};

export default KnowBeforeYouGo;
